import { render, staticRenderFns } from "./notification-ValidationCommented.vue?vue&type=template&id=3e1fb93a&scoped=true"
import script from "./notification-ValidationCommented.vue?vue&type=script&lang=js"
export * from "./notification-ValidationCommented.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1fb93a",
  null
  
)

export default component.exports